
import { Progress } from "@/components/ui/progress";

interface PasswordStrengthIndicatorProps {
  password: string;
  strength: number;
  feedback: string;
  progressColor: string;
}

/**
 * Component that visually indicates password strength
 * 
 * Shows a progress bar with color indicating strength level
 * and displays feedback text to guide password improvement
 */
export const PasswordStrengthIndicator = ({
  password,
  strength,
  feedback,
  progressColor
}: PasswordStrengthIndicatorProps) => {
  // Don't render anything if password is empty
  if (!password) return null;
  
  return (
    <>
      <Progress value={strength} className={`h-2 ${progressColor}`} />
      <p className={`text-sm ${strength === 100 ? 'text-green-400' : 'text-gray-400'}`}>
        {feedback}
      </p>
    </>
  );
};
